module.exports = __webpack_public_path__ + "static/media/Immusservices-min.da2466f2.jpg";